import type { ToastType } from "./toast.types.js";

type ToastHandler = (type: ToastType, message: string, title?: string, duration?: number) => void;

let _handler: ToastHandler | null = null;

export const toastEmitter = {
  /** Called by ToastProvider to register the showToast function */
  register(handler: ToastHandler) {
    _handler = handler;
  },

  /** Called by ToastProvider on unmount */
  unregister() {
    _handler = null;
  },

  /** Emit a toast from anywhere (inside or outside React) */
  emit(type: ToastType, message: string, title?: string, duration?: number) {
    if (_handler) {
      _handler(type, message, title, duration);
    } else {
      console.warn("[Toast] No ToastProvider mounted. Could not show toast:", { type, message, title });
    }
  },
};
